export const AboutUs = () => (
	<div className="policy-container">
		<h1>About MyBharatService</h1>
		<p>Welcome to <strong>MyBharatService</strong>, India's growing marketplace for essential professional services. We bridge the gap between quality providers and your immediate needs.</p>
		<p>Whether you are looking for dedicated Nursing care, specialized Physiotherapy, or reliable Lawyer and Ambulance services, Trusted Wedding Planner or Caterer, Home Tutor. our mission is to make professional assistance accessible and transparent for every household and Businesses.</p>

		{/* Footer for Legal Connection */}
		<footer style={{ marginTop: '30px', borderTop: '1px solid #ddd', paddingTop: '10px', fontSize: '0.85rem' }}>
			<p>MyBharatService is a registered brand name of <strong>CITIKART ONLINE SERVICE PRIVATE LIMITED</strong>. All rights reserved.</p>
		</footer>
	</div>
);
